<template>
  <div class="text-center">
    <div :class="{'d-none': loaded}">
      <h3>{{ trans.get('profile:edit.image_pre_add_modal.header') }}</h3>
      <br>

      <button type="button" class="button button__fill mx-auto mb-3" @click="triggerFileInput">{{ trans.get('profile:edit.image_pre_add_modal.button') }}</button>
    </div>
    <input
      type="file"
      id="image-input"
      accept="image/*"
      name="image"
      class="d-none"
      data-max-file-size="5120"
      @change="fileInputChange"
      ref="fileInput"
    >
    <span v-if="errorMessage" class="invalid-feedback d-block image-error" role="alert"><strong>{{ errorMessage }}</strong></span>
    <div class="row text-center">
      <div class="col-12">
        <div class="modal-add-image__cropper-modal">
          <img ref="imageCropperImg" id="image-cropper-img" src="" alt="">
        </div>
        <div class="slider-container" :class="{'d-none': !loaded}">
          <input
            ref="zoomSlider"
            type="range"
            min="0"
            max="4"
            step="0.01"
            value="0"
            novalidate
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CropperComponent',
  components: {},
  props: {
    open: Boolean
  },
  data() {
    return {
      loaded: false,
      selectors: {
        imageInput: 'image-input',
      },
      errorMessage: null,
      cropper: null,
      maxFileSize: 5120,
    };
  },
  computed: {},
  watch: {
    open: function (val) {
      if (val) {
        $(this.$refs.imageCropperImg).attr('src', '');
        if (this.cropper) {
          this.cropper.destroy();
          this.cropper = null;
        }
        this.errorMessage = null;
      }
    },
    loaded: function (val) {
      this.$emit('loaded', val);
    }
  },
  methods: {
    triggerFileInput() {
      // Wyzwolenie kliknięcia na ukrytym input
      this.$refs.fileInput.click();
    },
    fileInputChange: function (event) {
      const vm = this;
      let file = event.target.files[0];

      if ((file.size / 1024) > this.maxFileSize) {
        console.log("notify 1");
        new Noty({
          theme: 'metroui',
          type: 'error',
          text: vm.trans.get('profile:edit.add_image_modal.attachment_size'),
        }).show();

        vm.$emit('close');
      } else {
        this.initCropper();
      }
    },
    loadImagePreview: function (image) {
      let reader = new FileReader();
      let self = this;

      let promise = new Promise((resolve, reject) => {
        reader.onload = function (e) {
          $(self.$refs.imageCropperImg).attr('src', e.target.result);

          setTimeout(() => {
            resolve();
          }, 50);
        };
      });

      reader.readAsDataURL(image);
      return promise;
    },
    isImageFile: function (file) {
      if (file.type) {
        return /^image\/\w+$/.test(file.type);
      } else {
        return /\.(jpe?g|png|gif)$/i.test(file);
      }
    },
    initSlider: function (zoom = 0) {
      const self = this;
      $(self.$refs.zoomSlider).on('input', function (event) {
        const zoomValue = event.target.value;
        self.cropper.zoomTo(zoomValue);
      });
    },
    initCropper: function () {
      const self = this;
      const e = document.getElementById(self.selectors.imageInput);
      $(self.$refs.imageCropperImg).attr('src', '');

      if (self.cropper) {
        self.cropper.destroy();
        self.cropper = null;
      }
      self.errorMessage = null;
      let file = null;
      if (e.files && (file = e.files[0])) {
        if (self.isImageFile(file)) {
          this.loaded = true;
          self.loadImagePreview(e.files[0]).then(() => {
            self.setCropper();
          });
        } else {
          this.loaded = false;
          $(self.$refs.imageCropperImg).attr('src', '');

          self.errorMessage = 'Foto nur im JPG-, JPEG-, PNG- oder GIF-Format';
        }
      }
    },
    setCropper: function () {
      const self = this;
      const image = $(self.$refs.imageCropperImg)[0];

      self.cropper = new Cropper(image, {
        // aspectRatio: 1.5 / 2,
        aspectRatio: 580 / 800,
        viewMode: 3,
        guides: false,
        center: false,
        background: false,
        movable: true,
        cropBoxMovable: false,
        // minCropBoxWidth: 1,
        preview: '.crop_preview',
        autoCropArea: 1,
        scalable: true,
        dragMode: 'move',
        ready() {
          const minZoom = Math.round((this.cropper.canvasData.width / this.cropper.canvasData.naturalWidth) * 100) / 100;

          $(self.$refs.zoomSlider).attr('min', minZoom);
          $(self.$refs.zoomSlider).val(minZoom);
          this.cropper.zoomTo(minZoom);
        },
      });

      self.$emit('input', self.cropper);
    },
    submitForm: function () {

    }
  },
  mounted() {
    const self = this;

    const image = $(this.$refs.imageCropperImg)[0];
    if (image)
      image.addEventListener('ready', () => self.initSlider());
  }
};
</script>

<style lang="scss">
.slider-container {
  width: 100%;

  input {
    -webkit-appearance: none;
    width: 100%;
    height: 3px;
    background: #C63E7C;
    outline: none;

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 17px;
      height: 17px;
      border-radius: 50%;
      background: #C63E7C;
      cursor: pointer;
    }

    &::-moz-range-thumb {
      width: 17px;
      height: 17px;
      background: #C63E7C;
      cursor: pointer;
    }
  }
}
</style>
